import { render, staticRenderFns } from "./Wizard-3.vue?vue&type=template&id=8c67625c"
import script from "./Wizard-3.vue?vue&type=script&lang=js"
export * from "./Wizard-3.vue?vue&type=script&lang=js"
import style0 from "./Wizard-3.vue?vue&type=style&index=0&id=8c67625c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports